import React from 'react';
import './../TradeCard.css';
import { apiAppFetch } from '../utils/apiFetch';
import ScriptIcon from './ScriptIcon';
import { isMiniLot } from '../utils/lotVariant';

const TradeCard = ({ trade, refreshTradesAndPortfolio, isDarkMode = false }) => {
  const { orderId, stockId, stockName, orderType, autoCutDate, orderDateTime, exchange, orderPrice, orderQuantity, buy_sell, orderStatus, orderTransactionType, closeType } = trade;
  const quantityColor = buy_sell === 1 ? 'green' : 'red';
  //const statusText = orderStatus === '2' ? 'COMPLETE' : 'PENDING';
  const orderTransaction = orderTransactionType === 1 ? 'Open' : 'Close';
  const orderTransactionColor = orderTransactionType === 1 ? 'green' : 'red';

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const year = date.getFullYear();
    const month = date.toLocaleString('en-US', { month: 'short' });
    return `${day}-${month}-${year}`;
  };

  const cancelOrder = async () => {
    const confirmBox = window.confirm('Are you sure you want to cancel this pending order?');

    if (!confirmBox) {
      return;
    }

    try {
      const response = await apiAppFetch('cancelPendingOrder', {
        method: 'POST',
        body: JSON.stringify({
          stockId,
          orderId,
        }),
      });

      if (response.status === 401) {
        return;
      }

      const data = await response.json();

      if (data.success) {
        alert(data.message);
        refreshTradesAndPortfolio('both');
      }
    } catch (error) {
      // cancel request failed
    }
  };

  // const orderTypeText = (orderType, buy_sell) => {
  //   switch(Number(orderType)){
  //       case "1" || 1:
  //         return "MARKET";
  //       case "2" || 2:
  //         {
  //           switch(buy_sell){
  //             case "1" || 1:
  //               return "BUY LIMIT";
  //             case "2" || 2:
  //               return "SELL LIMIT";
  //           }
  //         }
  //         //return "LIMIT";
  //       case "3" || 3:
  //         return "STOP LOSS";
  //   }
  // };

  const orderTypeText = (type, side) => {
    const orderTypeKey = String(type);
    const buySellKey = String(side);

    if(closeType === 1) {
      return 'AUTO EXIT';
    }

    switch (orderTypeKey) {
      case '1':
        if (buySellKey === '1') return 'BUY MARKET';
        if (buySellKey === '2') return 'SELL MARKET';
        return 'MARKET';
      case '2':
        if (buySellKey === '1') return 'BUY LIMIT';
        if (buySellKey === '2') return 'SELL LIMIT';
        return 'LIMIT';
      case '3':
        return 'STOP LOSS';
      default:
        return '';
    }
  };

  const orderStatusKey = String(orderStatus);
  const isCancelled = orderStatusKey === '4' || String(trade.isCancelled) === '1';

  return (
    <div className={`trade-card ${isDarkMode ? 'dark-theme' : 'light-theme'}`} data-theme={isDarkMode ? 'dark' : 'light'}>
        <div className="d-flex justify-content-between align-items-center">
            <h4 className="trade-scriptName">
              <ScriptIcon name={stockName} size={28} />
              <span className="script-identity-title">
                {stockName}
                {isMiniLot(trade) && <span className="lot-variant-mini">MINI</span>}
              </span>
            </h4>
            <div className="trade-price">{Number(orderPrice).toFixed(2)}</div>
        </div>
        <div className="trade-meta d-flex justify-content-between align-items-center">
            <span className="trade-dateTime">Expiry {formatDate(trade.autoCutDate)}</span>
            <span className='trade-dateTime'>{new Date(orderDateTime).toLocaleString()}</span>
        </div>
        <div className="trade-stats">
            <div className="trade-stat">
                <span className="trade-stat-label">Qty</span>
                <span className={`trade-stat-value ${quantityColor}`}>
                    {buy_sell === 1 ? '+' : '-'}{Number(orderQuantity).toFixed(2)}
                </span>
            </div>
            <div className="trade-stat">
                {/* <span className="trade-stat-label">Type</span> */}
                <span style={{fontSize: '10px'}} className="trade-stat-value">{orderTypeText(orderType, buy_sell)}</span>
            </div>
            <div className="trade-stat">
                {isCancelled ? (
                    <span className="trade-stat-value trade-cancelled">Cancelled</span>
                ) : (
                    <>
                        <span className="trade-stat-label">Side</span>
                        <span className={`trade-stat-value ${orderTransactionColor}`}>{orderTransaction}</span>
                    </>
                )}
            </div>
            {orderStatusKey === '1' && (
                <button
                    type="button"
                    className="trade-cancel-btn"
                    onClick={cancelOrder}
                >
                    Cancel
                </button>
            )}
        </div>
    </div>
  );
};

export default TradeCard;
